import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import * as moment from "moment";

@Component({
	selector: "app-view-class-attendance-history",
	templateUrl: "./view-class-attendance-history.component.html",
	styleUrls: ["./view-class-attendance-history.component.css"],
})
export class ViewClassAttendanceHistoryComponent implements OnInit {
	constructor(private dialogConfig: DynamicDialogConfig, private ref: DynamicDialogRef) {}

	ngOnInit(): void {
		//Get data from DB
		this.SelectedPerson = this.dialogConfig.data.SelectedPerson;
		this.SelectedEntry = this.dialogConfig.data.SelectedEntry;
		this.SelectedHistory = this.dialogConfig.data.SelectedHistory;

		//Update Display
		this.StudentID = this.SelectedPerson.DesignatorID;
		this.StudentName = this.SelectedPerson.PersonName;
		this.Section = this.SelectedEntry.Section;
		this.Status = this.SelectedHistory.ClassAttendanceStatusDesc;
		this.Excuse = this.SelectedHistory.ClassAttendanceExcuseDesc;
		this.EntryMethod = this.SelectedHistory.ClassAttendanceEntryTypeDesc;
		this.OriginalDate = this.SelectedEntry.EntryDateDesc;
		this.Created = moment(new Date(this.SelectedHistory.c_date)).format("MM/DD/YYYY h:mm a");
		this.CreatedBy = this.SelectedHistory.c_PersonName;
		this.CreatedByType = this.SelectedHistory.c_PersonTypeDesc;
		this.CreatedByTitle = this.SelectedHistory.c_PersonTitle;
		this.RecordStatus = this.SelectedHistory.RecordStatusDesc;

		if (this.Excuse == "") {
			this.Excuse = "N/A";
		}
		if (this.CreatedByTitle == "") {
			this.CreatedByTitle = "N/A";
		}

		if (this.SelectedHistory.EntryTime == "" || this.SelectedHistory.EntryTime == "0001-01-01T00:00:00") {
			this.EntryTime = "Not Defined";
		} else {
			this.EntryTime = moment(new Date(this.SelectedHistory.EntryTime)).format("h:mm a");
		}

		if (this.SelectedHistory.ExitTime == "" || this.SelectedHistory.ExitTime == "0001-01-01T00:00:00") {
			this.ExitTime = "Not Defined";
		} else {
			this.ExitTime = moment(new Date(this.SelectedHistory.ExitTime)).format("h:mm a");
		}
	}

	///////////////////////////////////////
	// Data
	///////////////////////////////////////

	//Data from parent
	SelectedPerson: any;
	SelectedEntry: any;
	SelectedHistory: any;

	//Display Data
	StudentID: any;
	StudentName: any;
	Section: any;
	Status: any;
	Excuse: any;
	EntryMethod: any;
	OriginalDate: any;
	Created: any;
	CreatedBy: any;
	CreatedByType: any;
	CreatedByTitle: any;
	RecordStatus: any;
	EntryTime: any;
	ExitTime: any;
	///////////////////////////////////////

	///////////////////////////////////////
	// Buttons
	///////////////////////////////////////
	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////
}
